import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
const plans = [
    {
        name: "Starter",
        description: "Perfect for small businesses and startups",
        price: "$2,999",
        period: "one-time",
        features: [
            "Custom landing page",
            "Responsive design",
            "Basic SEO setup",
            "Contact form",
            "1 revision round",
            "1 month support",
        ],
        cta: "Get Started",
        href: "/contact?plan=starter",
        popular: false,
    },
    {
        name: "Professional",
        description: "For growing businesses that need more",
        price: "$7,999",
        period: "one-time",
        features: [
            "Up to 5 pages",
            "Custom design",
            "Advanced SEO",
            "CMS integration",
            "Analytics setup",
            "3 revision rounds",
            "3 months support",
            "Performance optimization",
        ],
        cta: "Get Started",
        href: "/contact?plan=professional",
        popular: true,
    },
    {
        name: "Enterprise",
        description: "Full-scale solutions for large organizations",
        price: "Custom",
        period: "project",
        features: [
            "Unlimited pages",
            "Custom web application",
            "API development",
            "Database design",
            "Cloud infrastructure",
            "CI/CD pipeline",
            "Unlimited revisions",
            "12 months support",
            "Dedicated project manager",
        ],
        cta: "Contact Sales",
        href: "/contact?plan=enterprise",
        popular: false,
    },
];
export function Pricing({ showHeader = true }) {
    return (_jsx("section", { className: "section-padding", children: _jsxs("div", { className: "container-page", children: [showHeader && (_jsxs("div", { className: "mx-auto max-w-2xl text-center", children: [_jsx("h2", { className: "text-3xl font-bold tracking-tight sm:text-4xl", children: "Simple, transparent pricing" }), _jsx("p", { className: "mt-4 text-lg text-muted-foreground", children: "Choose the plan that fits your needs. No hidden fees." })] })), _jsx("div", { className: "mt-16 grid gap-8 lg:grid-cols-3", children: plans.map((plan) => (_jsxs("div", { className: cn("relative rounded-xl border bg-card p-8 transition-all hover:shadow-lg", plan.popular && "border-primary shadow-md"), children: [plan.popular && (_jsx(Badge, { className: "absolute -top-3 left-1/2 -translate-x-1/2", children: "Most Popular" })), _jsxs("div", { children: [_jsx("h3", { className: "text-xl font-semibold", children: plan.name }), _jsx("p", { className: "mt-1 text-sm text-muted-foreground", children: plan.description }), _jsxs("div", { className: "mt-4", children: [_jsx("span", { className: "text-4xl font-bold", children: plan.price }), _jsxs("span", { className: "ml-1 text-sm text-muted-foreground", children: ["/ ", plan.period] })] })] }), _jsx("ul", { className: "mt-6 space-y-3", children: plan.features.map((feature) => (_jsxs("li", { className: "flex items-start text-sm", children: [_jsx(Check, { className: "mr-2 mt-0.5 h-4 w-4 shrink-0 text-success" }), feature] }, feature))) }), _jsx(Button, { variant: plan.popular ? "default" : "outline", className: "mt-8 w-full", asChild: true, children: _jsx(Link, { to: plan.href, children: plan.cta }) })] }, plan.name))) })] }) }));
}
